import React, { useContext } from 'react';
import { mutableValue, } from '@polestar/component-warehouse-react/hooks/useMutableValue';
/**
 * @internal
 */
export const GalleryContext = React.createContext({
    id: 'gallery-x',
    inGallery: false,
    index: mutableValue(0),
    internalIndex: mutableValue(0),
    isInView: mutableValue(false),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setIndex: (index) => null,
});
/**
 * @internal
 */
export const useGallery = () => {
    return useContext(GalleryContext);
};
